export default "__VITE_ASSET__60c57081__"